import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppButton, Box, RawButton, Text } from '@common-fe/common-fe';

import Modal from '@/components/elements/AutoBlockedModal/Modal';

interface Props {
  children: React.ReactNode;
  title: string;
  text: string;
}

const InfoModal: React.FC<Props> = ({ title, children, text }) => {
  const { t } =useTranslation();
  const [isShowed, setShowed] = useState(false);
  const handleToggle = useCallback(() => {
    setShowed(!isShowed);
  }, [isShowed]);
  return (
    <>
      <RawButton style={{display: 'inline-flex'}} data-testid={`info-modal_${title}_button`} onClick={handleToggle}>
        {children}
      </RawButton>
      <Modal testId={`info-modal_${title}`} visible={isShowed} onSetVisible={handleToggle}>
        <Box>
          <Box align='center'>
            <Text size="2xl"   data-testid={`info-modal_${title}`}>{title}</Text>
            <Text textAlign='center' size="medium" data-testid={`info-modal_${title}_text`} margin={{top: 's'}}>{text}</Text>
          </Box>
          <Box direction='row' justify='end' margin={{top: 'l'}}>
            <AppButton testId={`info-modal_${title}_cancel`} width='160px' buttonType="secondary" onClick={handleToggle}>
              {t('Cancel')}
            </AppButton>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default InfoModal;